module.exports = __webpack_public_path__ + "static/media/baNANA.6716fe05.jpeg";